"use strict";

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** @typedef {import("vue/types/vue").ExtendedVue} ExtendedVue  */

var LONG_TAP_MS = 1000;
var DOUBLE_EVENT_TIMESPAN_MS = 100;

/** @class TouchTimer */

var TouchTimer = function () {
  function TouchTimer() {
    _classCallCheck(this, TouchTimer);

    this.debounceTimer = null;
    this.touchTimer = null;
  }

  /**
   * Method to debounce touchend and click events firing together on iPhone
   * @param {function} callback
   * @param {number} time
   * @returns {void}
   */
  TouchTimer.prototype.debounce = function debounce(callback) {
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DOUBLE_EVENT_TIMESPAN_MS;

    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(callback, time);
  };

  /**
   * Method to check if the current option touch timer is the same as the globally
   * currently active timer that was triggered by the first touchstart event
   * @param {ExtendedVue} context
   * @returns {boolean}
   */
  TouchTimer.prototype.isCurrentTimer = function isCurrentTimer(context) {
    return context.touchTimer && this.touchTimer && this.touchTimer === context.touchTimer;
  };

  /**
   * Method that creates a timer to distinguish between a tap and a long tap
   * @param {ExtendedVue} context
   * @returns {void}
   */
  TouchTimer.prototype.startTimer = function startTimer(context) {
    var _this = this;

    this.touchTimer = setTimeout(function () {
      context.touchTimer = null;
      _this.stopTimer();
    }, LONG_TAP_MS);
  };

  /**
   * Method that stops the touch timer
   * @returns {void}
   */
  TouchTimer.prototype.stopTimer = function stopTimer() {
    clearTimeout(this.touchTimer);
    this.touchTimer = null;
  };

  _createClass(TouchTimer, [{
    key: "isTouchTimerActive",


    /**
     * Getter to check if the touch timer is active
     * @returns {boolean}
     */
    get: function get() {
      return !!this.touchTimer;
    }
  }]);

  return TouchTimer;
}();

;

var timer = new TouchTimer();

exports.timer = timer;